import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { rating2scaleLabel } from '~/assets/helper/functions';
import { EnumIroType, useGetIroQuery, useUpdateIroMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'likelihood',
  setup: function setup(__props) {
    var route = useRoute();
    var _useGetIroQuery = useGetIroQuery(computed(function () {
        return {
          id: route.params.id
        };
      })),
      result = _useGetIroQuery.result,
      onResult = _useGetIroQuery.onResult;
    var initStatusOnce = _.once(function (data) {
      var _data$getIro;
      editing.value = !((_data$getIro = data.getIro) !== null && _data$getIro !== void 0 && _data$getIro.likelihoodReason);
    });
    var disabled = computed(function () {
      var _result$value, _result$value$getIro, _result$value2, _result$value2$getIro;
      if ([EnumIroType.PositiveImpact, EnumIroType.NegativeImpact].includes((_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getIro = _result$value.getIro) === null || _result$value$getIro === void 0 ? void 0 : _result$value$getIro.type) && !((_result$value2 = result.value) !== null && _result$value2 !== void 0 && (_result$value2$getIro = _result$value2.getIro) !== null && _result$value2$getIro !== void 0 && _result$value2$getIro.levelOfImpact)) {
        return true;
      }
    });
    onResult(function (_ref) {
      var _data$getIro2;
      var data = _ref.data;
      if (data !== null && data !== void 0 && data.getIro) {
        initStatusOnce(data);
      }
      // this part is only for IMPACT
      if ([EnumIroType.PositiveImpact, EnumIroType.NegativeImpact].includes(data === null || data === void 0 ? void 0 : (_data$getIro2 = data.getIro) === null || _data$getIro2 === void 0 ? void 0 : _data$getIro2.type) && editing.value === false) {
        // we only open, but close is controlled by user clicking "done"
        editing.value = !data.getIro.likelihood; // open this input when likelihoodReason or likelihood has no value
        if (!data.getIro.levelOfImpact) {
          editing.value = false;
        }
      }
      // end of IMPACT part

      if (disabled.value) {
        editing.value = false;
      }
    });
    var item = computed(function () {
      var _result$value3;
      return (result === null || result === void 0 ? void 0 : (_result$value3 = result.value) === null || _result$value3 === void 0 ? void 0 : _result$value3.getIro) || {};
    });
    var _useUpdateIroMutation = useUpdateIroMutation(),
      updateIRO = _useUpdateIroMutation.mutate,
      onDone = _useUpdateIroMutation.onDone;
    onDone(function (data) {
      window.$nuxt.$emit('userMsg');
    });
    var editing = ref(false);
    return {
      __sfc: true,
      route: route,
      result: result,
      onResult: onResult,
      initStatusOnce: initStatusOnce,
      disabled: disabled,
      item: item,
      updateIRO: updateIRO,
      onDone: onDone,
      editing: editing,
      rating2scaleLabel: rating2scaleLabel,
      EnumIroType: EnumIroType
    };
  }
});